import { pdkAxios } from '@/lib/pdk-axios';
import type { Deal } from '@/models/registry';
import { dealStore } from '@/models/stores';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type Variables = {
  delivery_preference: Deal['delivery_preference'];
};

export const useUpdateDeliveryPreferenceMutation = ({
  dealId,
  onSuccess,
  onError,
}: {
  dealId: string;
  onSuccess?: (data: Deal, variables: Variables) => void;
  onError?: (error: Error, variables: Variables) => void;
}) => {
  const queryClient = useQueryClient();

  const updateDeliveryPreferenceMutation = useMutation({
    onMutate: async ({ delivery_preference }) => {
      if (!dealId) return;

      dealStore.updateDeliveryPreference({
        id: dealId,
        deliveryPreference: delivery_preference,
      });
    },
    mutationFn: async ({
      delivery_preference,
    }: {
      delivery_preference: Deal['delivery_preference'];
    }) => {
      const response = await pdkAxios
        .post(`/deals/${dealId}/delivery-preference`, {
          delivery_preference,
        })
        .catch((e) => {
          console.error('Error updating delivery preference', e);
          throw e;
        });

      return response.data;
    },
    onSuccess: (data, variables) => {
      onSuccess?.(data, variables);
    },
    onError: (error, variables) => {
      onError?.(error, variables);

      console.error('Error updating delivery preference', error, variables);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['deal', dealId] });
    },
  });

  return { updateDeliveryPreferenceMutation };
};

export default useUpdateDeliveryPreferenceMutation;
